import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { leadService } from "@/pages/verve-leads/leads/services/leadService";

export const useDateFilteredLeads = (params = {}, filters = {}) => {
  const query = useQuery({
    queryKey: ['verve-leads', params, filters],
    queryFn: async () => {
      const response = await leadService.getLeads(params);
      return response?.data || response;
    },
    placeholderData: keepPreviousData,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
